export default {
  data: function () {
    return {
      featureGroupName: '',
      fetchComplete: false
    }
  },
  methods: {
    getFeatures: function (nextPageToken = '') {
      // get features for this component
      this.$store.dispatch('getUserFeatures', { groupName: this.featureGroupName, nextPageToken: nextPageToken }).then((response) => {
        if (response.hasMore) {
          this.getFeatures(response.nextPageToken !== -1 ? response.nextPageToken : '')
        } else {
          this.fetchComplete = true
        }
      })
    },
    hasFeature: function (featureName) {
      return this.features.length > 0 && this.features.some(feature => feature.name === featureName)
    }
  },
  computed: {
    features: function () {
      return this.$store.getters.features(this.featureGroupName)
    }
  }
}
